export class AuthStateModel {
  token?: string;
  surveyToken?: string;
  email?: string;
}

export class Login {
  static readonly type = '[Auth] Login';
  constructor(public payload: { email: string; password: string }) {}
}

export class SeamlessLogin {
  static readonly type = '[Auth] SeamlessLogin';
  constructor(public payload: { email: string; token: string }) {}
}

export class AuthenticateSurvey {
  static readonly type = '[Auth] AuthenticateSurvey';
  constructor(public payload: string) {}
}

export class LogoutSucceeded {
  static readonly type = '[Auth] LogoutSucceeded';
}
